import { render, staticRenderFns } from "./docindex.vue?vue&type=template&id=94f87088&scoped=true&"
import script from "./docindex.vue?vue&type=script&lang=js&"
export * from "./docindex.vue?vue&type=script&lang=js&"
import style0 from "./docindex.vue?vue&type=style&index=0&id=94f87088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f87088",
  null
  
)

export default component.exports